angular.module("app").controller("LoginController", [
    '$scope',
    'userService',
    'userStorage',
    '$state',
    'settingsService',
    '$cookies',
    function ($scope, userService, userStorage, $state, settingsService, $cookies) {
        var init;

        (init = function () {
            $scope.userInfo = {
                username: "",
                password: ""
            };
        })();

        $scope.error = {};

        $scope.submitForm = function (login_form) {
            userService.login($scope.userInfo).then(
                function (userData) {
                    if (userData.status == "ok") {
                        $cookies.remove("preferedLanguage");
                        preLoadNecessaryData().then(
                            function (response) {
                                if (response.status == "ok") {
                                    userStorage.setUserData(angular.copy(response.userInfo));
                                    settingsService.setSettings(angular.copy(response));
                                    init();
                                    login_form.$setPristine();
                                    $state.go("main.configs", null, {reload: true});
                                }
                            }
                        );

                    } else {
                        $scope.error.errorCode = userData.message;
                    }
                },
                function (response) {
                    //TODO handle error
                }
            );
        }
    }
]);